// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
let RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

let Types = {};

function unwrap_response_updateAgentSocialMediaHandles(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, ["Agent"]);
}

let variablesConverter = {"updateAgentSocialMediaHandlesInput":{},"__root":{"input":{"r":"updateAgentSocialMediaHandlesInput"}}};

function convertVariables(v) {
  return RescriptRelay.convertObj(v, variablesConverter, undefined, undefined);
}

let wrapResponseConverter = {"__root":{"updateAgentSocialMediaHandles_Agent":{"f":""},"updateAgentSocialMediaHandles":{"u":"response_updateAgentSocialMediaHandles"}}};

let wrapResponseConverterMap = {
  response_updateAgentSocialMediaHandles: RescriptRelay_Internal.wrapUnion
};

function convertWrapResponse(v) {
  return RescriptRelay.convertObj(v, wrapResponseConverter, wrapResponseConverterMap, null);
}

let responseConverter = {"__root":{"updateAgentSocialMediaHandles_Agent":{"f":""},"updateAgentSocialMediaHandles":{"u":"response_updateAgentSocialMediaHandles"}}};

let responseConverterMap = {
  response_updateAgentSocialMediaHandles: unwrap_response_updateAgentSocialMediaHandles
};

function convertResponse(v) {
  return RescriptRelay.convertObj(v, responseConverter, responseConverterMap, undefined);
}

let Internal = {
  variablesConverter: variablesConverter,
  variablesConverterMap: undefined,
  convertVariables: convertVariables,
  wrapResponseConverter: wrapResponseConverter,
  wrapResponseConverterMap: wrapResponseConverterMap,
  convertWrapResponse: convertWrapResponse,
  responseConverter: responseConverter,
  responseConverterMap: responseConverterMap,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapResponse,
  convertRawResponse: convertResponse
};

let Utils = {};

let node = ((function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "facebookHandle",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "instagramHandle",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "linkedInHandle",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tikTokHandle",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "twitterHandle",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "yelpHandle",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "youTubeHandle",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UnifiedYourProfileSocialMediaForm_UpdateAgentSocialMediaHandlesMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "updateAgentSocialMediaHandles",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "UnifiedYourProfileSocialMediaForm_agent"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "AgentSocialMediaAccounts",
                "kind": "LinkedField",
                "name": "socialMedia",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "Agent",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UnifiedYourProfileSocialMediaForm_UpdateAgentSocialMediaHandlesMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "updateAgentSocialMediaHandles",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "AgentSocialMediaAccounts",
                "kind": "LinkedField",
                "name": "socialMedia",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "Agent",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "nodeId",
                "storageKey": null
              }
            ],
            "type": "Node",
            "abstractKey": "__isNode"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "561389769af734206a30556ab17da6c5",
    "id": null,
    "metadata": {},
    "name": "UnifiedYourProfileSocialMediaForm_UpdateAgentSocialMediaHandlesMutation",
    "operationKind": "mutation",
    "text": "mutation UnifiedYourProfileSocialMediaForm_UpdateAgentSocialMediaHandlesMutation(\n  $input: UpdateAgentSocialMediaHandlesInput!\n) {\n  updateAgentSocialMediaHandles(input: $input) {\n    __typename\n    ... on Agent {\n      ...UnifiedYourProfileSocialMediaForm_agent\n      socialMedia {\n        facebookHandle\n        instagramHandle\n        linkedInHandle\n        tikTokHandle\n        twitterHandle\n        yelpHandle\n        youTubeHandle\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      __typename\n      nodeId\n    }\n  }\n}\n\nfragment UnifiedYourProfileSocialMediaForm_agent on Agent {\n  id\n  socialMedia {\n    tikTokHandle\n    facebookHandle\n    instagramHandle\n    linkedInHandle\n    twitterHandle\n    yelpHandle\n    youTubeHandle\n  }\n}\n"
  }
};
})());

let wrap_response_updateAgentSocialMediaHandles = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_response_updateAgentSocialMediaHandles = unwrap_response_updateAgentSocialMediaHandles;
exports.wrap_response_updateAgentSocialMediaHandles = wrap_response_updateAgentSocialMediaHandles;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* node Not a pure module */
